export enum SmsType {
  DebtRemind = 1,
}
